const PUBLIC = process.env.PUBLIC_URL || '';

export const AUTH_HERO_SLIDES = [
  {
    img: `${PUBLIC}/images/img2.png`,
    fit: 'gate',
    title: 'RFID Gate & Secure Tracking',
    desc: 'Automate entry and exit logging with Sparkle RFID gates. Real-time monitoring for warehouses, showrooms, and secure stock movement.',
  },
  {
    img: `${PUBLIC}/images/IMG3.png`,
    fit: 'dashboard',
    title: 'Jewellery Intelligence Dashboard',
    desc: 'Track inventory, sales, and RFID tags in one place — built for jewellery retail with live analytics and alerts.',
  },
  {
    img: `${PUBLIC}/images/Img1.png`,
    fit: 'showroom',
    title: 'RFID Scan at the Jewellery Counter',
    desc: 'Read the tag on a necklace or piece at the counter. Sparkle handheld scanners confirm stock instantly on the showroom floor.',
  },
  {
    img: `${PUBLIC}/images/RFIDROBOT.png`,
    fit: 'robot',
    title: 'Automated Jewellery Inventory',
    desc: 'Precision RFID scanning for high-value stock. Sparkle RFID brings automated inventory, secure vault tracking, and showroom accuracy to jewellery retail.',
  },
];
